import React from 'react';
import Story from "./Story";
import "./StoryReel.css";


function StoryReel() {
    return (
        <div className="storyReel">
         
            <Story 
                image=""
                profileSec=""
                title="Make appoinment"
               
            />
              <Story
                image=""
                profileSec=""
                title="Enter to win "
            />
              <Story
                image=""
                profileSec=""
                title="See all the winners"
            />
              <Story
                image=""
                profileSec=""
                title="Special Offers"
            />
        </div>
    )
}

export default StoryReel
